import React from "react";

const TableOfContents = ({ headings, activeSection, onSelect }) => {
  return (
    <aside className="help-toc-sticky">
      <div className="help-toc">
        <div className="help-toc-title">On this page</div>
        <div className="help-toc-divider" aria-hidden="true" />
        <div className="help-toc-panel">
          <div className="help-toc-list">
            {headings.map((heading) => (
              <button
                key={heading.id}
                type="button"
                className={`help-toc-link ${
                  activeSection === heading.id ? "is-active" : ""
                } help-toc-link--level-${heading.level || 2}`}
                onClick={() => onSelect(heading.id)}
              >
                {heading.title}
              </button>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default TableOfContents;
